<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import ErrorMessage from "../../components/error-message";

/**
 * Invoice-detail component
 */
export default {
    components: { ErrorMessage,Layout, PageHeader },
    data() {
        return {
            errorMessage: "",
            title: "Agent Details",
            items: [
                {
                    text: "Agent",
                    href: "/"
                },
                {
                    text: "Details",
                    active: true
                }
            ],
            errors: null,
            agent_uuid:"",
            agent:[],
            agency:[],
            user:[],
            booking:"",
            status:"",
            visible:false,
            message:"",
        };
    },
    created() {
        this.agent_uuid = this.$route.params.id;
    },
    mounted() {
        this.getAgentDetails();
    },
    methods: {
        onClose(){
            this.visible=false;
        },
        getAgentDetails(){
            var _this = this;
            let uuid=this.agent_uuid;
            try{
                axios
                    .post("/api/user-agent/detail/" + uuid, {
                        accessToken: localStorage.getItem("access_tocken"),
                    })
                    .then((response) => {
                        if (response.data.status) {
                            console.log(response.data.data.data);
                            this.agent=response.data.data.data;
                            this.agency=response.data.data.data.agency_information[0];
                            this.user=response.data.data.data.users[0];
                        }else {
                            var str = response.data.message;
                            var jsonParse = JSON.parse(str);
                            _this.errorCheck(jsonParse);
                        }
                    })
                    .catch((error) => {
                        console.log(error.message);
                    });
            } catch (err) {
                console.log(err);
            }
        },
        errorCheck(obj) {
            if(obj.statusCode == 403){
                this.visible=true;
                this.message="Access Permission Denied";
                this.errors = obj.message;
            }else if (obj.error) {
                this.errors = obj.message;
            } else if (obj.message == "Token has expired") {
                this.$swal.fire({
                    title: 'LogOut!',
                    text: 'Token Has Expired',
                    icon: 'error',
                    toast:'true',
                    position: 'top-end',
                });
                this.$router.push({ name: "logout" });
            } else if (
                obj.message !== "Token has expired" &&
                obj.message !== "The given data was invalid."
            ) {
                this.errors = obj.message;
            } else if (obj.message == "The given data was invalid.") {
                this.errors = obj.errors;
            } else {
                this.flashMessage.show({
                    time: 5000,
                    status: "error",
                    title: "Error",
                    message: "Problem in data save",
                });
            }
        },
    },
};
</script>

<template>
    <Layout>
        <h4>Agency Info</h4>
        <div class="table-responsive table-bordered table-sm">
            <table class="table">
                <thead>
                <tr>
                    <th>Name</th>
                    <th>Address</th>
                    <th>Iata No.</th>
                    <th>Trade Licence</th>
                    <th>Postal Code</th>
                    <th>Website</th>
                    <th>Fax</th>
                    <th>City</th>
                    <th>Country</th>
                    <th>CA Certificate</th>

                </tr>
                </thead>
                <tbody>
                <tr>
                    <td>{{agency.agency_name}}</td>
                    <td>{{agency.address}}</td>
                    <td>{{agency.iata_no}}</td>
                    <td>{{agency.trade_license_no}}</td>

                    <td>{{agency.postal_code}}</td>
                    <td>{{agency.website}}</td>
                    <td>{{agency.fax_no}}</td>
                    <td>{{agency.city}}</td>
                    <td>{{agency.country}}</td>
                    <td>{{agency.civil_aviation_certificate_no}}</td>
                </tr>
                </tbody>

                <!--                                </tbody>-->
            </table>
        </div>
        <div class="table-responsive table-bordered table-sm">
            <table class="table">
                <thead>
                <tr>

                    <th>Management Full Name</th>
                    <th>Management Ownership Title	</th>
                    <th>Management Phone No</th>
                    <th>Management Email</th>
                    <th>Contact Person Full Name</th>
                    <th>Contact Person Email</th>
                    <th>Contact Person Phone No</th>
                </tr>
                </thead>
                <tbody>
                <tr>

                    <td>{{agency.management_full_name}}</td>
                    <td>{{agency.management_ownership_title}}</td>

                    <td>{{agency.management_phone_number}}</td>
                    <td>{{agency.management_email}}</td>
                    <td>{{agency.contact_person_full_name}}</td>
                    <td>{{agency.contact_person_email}}</td>
                    <td>{{agency.contact_person_phone_number}}</td>
                </tr>
                </tbody>

                <!--                                </tbody>-->
            </table>
        </div>

        <h4>Agent Information</h4>
        <div class="table-responsive table-bordered table-sm">
            <table class="table mb-0">
                <thead>
                <tr>
                    <th>First Name</th>
                    <th>Last Name</th>
                    <th>Email</th>
                    <th>Phone No</th>
                    <th>Gender</th>
                    <th>Postal Code</th>
                    <th>Country Code</th>
                    <th>Country</th>
                    <th>Currency</th>
                    <th>City</th>
                    <th>Markup Amount</th>
                    <th>Markup Type</th>
                    <th>Language</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td>{{agent.first_name}}</td>
                    <td>{{agent.last_name}}</td>
                    <td>{{agent.email}}</td>
                    <td>{{agent.phone_code}}{{agent.phone_number}}</td>
                    <td>{{agent.gender}}</td>
                    <td>{{agent.postal_code}}</td>
                    <td>{{agent.country_code}}</td>
                    <td>{{agent.country}}</td>
                    <td>{{agent.currency}}</td>
                    <td>{{agent.city}}</td>
                    <td>{{agent.markup_amount}}</td>
                    <td>{{agent.markup_type}}</td>
                    <td>{{agent.language}}</td>
                </tr>
                </tbody>

                <!--                                </tbody>-->
            </table>
        </div>
        <!--                            </table>-->
        <br>

        <div>

            <!--                            <table>-->
            <h4>User Information</h4>
            <div class="table-responsive table-bordered table-sm">
                <table class="table mb-0">
                    <thead>
                    <tr>
                        <th>First Name</th>
                        <th>Last Name</th>
                        <th>Email</th>
                        <th>Phone No</th>
                        <th>Gender</th>
                        <th>Country Code</th>
                        <th>Country</th>
                        <th>Account Status</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td>{{user.first_name}}</td>
                        <td>{{user.last_name}}</td>
                        <td>{{user.email}}</td>
                        <td>{{user.phone_code}}{{user.phone_number}}</td>
                        <td>{{user.gender}}</td>
                        <td>{{user.country_code}}</td>
                        <td>{{user.country}}</td>
                        <td>{{user.status}}</td>
                    </tr>
                    </tbody>

                    <!--                                </tbody>-->
                </table>
            </div>
            <!--                            </table>-->
        </div>
        <div class="d-print-none">
            <div class="float-right">
                <a @click.prevent="print(booking.id)" class="btn btn-success">
                    <i class="fa fa-print"></i>
                </a>
                <a href="javascript: void(0);" class="btn btn-primary w-md ml-1">Send Email</a>
            </div>
        </div>
        <!-- end row -->
    </Layout>
</template>

<style scoped>
tr>td{
    width:35%;
    height:30px;
}
.padding-2percent{
    padding-top: 2%;
}
</style>

<style scoped>
tr>td{
    width:35%;
    height:30px;
}
.padding-2percent{
    padding-top: 2%;
}
</style>
